export enum TabKeyEnum {
  MyDay = "myday",
  Chat = "chat",
  Language = "language",
  Profile = "profile",
  Members = "Members",
  Feed = "idenedi",
  Library = "tlibrary",
  Calendar = "tevents",
  Boards = "isp",
  ContactCard = "bcard",
  ScoreCard = "Score Card",
  ssnotes = "ssnotes",
  Requests = "esp",
  EspRecords = "espRecords",
  EspSurveys = "EspSurveys",
  Dashboards = "kpowerbi",
  MiM = "ssa",
  Activities = "ss",
  Blog = "blogs",
  Vacancies = "higher",
  Messages = "messages",
  Intajy = "Intajy",
  CustomersService = "CustomersService",
  EngagementPro = "Engpro",
  Custom = "custom",
  Contacts = "contacts",
  SocialMedia = "socialmedia",
  Home = 'home',
  EspAttendance= 'espAttendance',
  Sellexe = 'OpportunityPro',
  NotificationCenter = 'NotificationCenter',
  ForYou = 'stemexeNotificationCenter',
  SimpleStrataReview = "ssreview",
  AdminSpace = 'Admin Space',
  ConnecteXeDedicationReport = "Connectexe",
  Search = "Search"
}
